/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    strokeColor?: keyof typeof theme.colors;
};

export default function EyeIcon({ strokeColor, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            width="25"
            height="18"
            viewBox="0 0 25 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            role="img"
        >
            <path
                d="M1.62 9.373S5.555 1.5 12.444 1.5c6.888 0 10.825 7.873 10.825 7.873s-3.937 7.873-10.825 7.873c-6.89 0-10.826-7.873-10.826-7.873Z"
                stroke={strokeColor ? theme.colors[strokeColor] : '#282B43'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.445 12.327a2.952 2.952 0 1 0 0-5.905 2.952 2.952 0 0 0 0 5.905Z"
                stroke={strokeColor ? theme.colors[strokeColor] : '#282B43'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
